import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from '../../../../../../src/app/website/services/environment.service';
import { validateUploadFile } from '../../../../../../src/app/website/utils/upload-file.validators';

export interface UploadedFile {
  createdDate: string;
  filename: string;
  folder: string;
  id: string;
  originalFilename?: string;
  thumbnail?: string;
}

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  constructor(
    private httpClient: HttpClient,
    private environment: Environment
  ) {}

  public upload(file: File): Promise<UploadedFile> {
    validateUploadFile(file);

    return this.httpClient
      .post<UploadedFile>(`${this.environment.apiUrl}/servlet/uploadFile`, file, {
        params: { filename: file.name },
        headers: { 'Content-Type': file.type },
        withCredentials: true
      })
      .toPromise();
  }
}
